import React from "react";
import SwitchToggle from "../../components/SwitchToggle";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";

// Types
interface ReportedMessage {
  message: string;
  reportedBy: string;
  reason: string;
  date: string;
  status: string;
}

interface Group {
  name: string;
  description: string;
  category: string;
  members: number;
  createdDate: string;
  status: boolean;
  reportedMessages: ReportedMessage[];
}

const ViewCommunityGroup: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const group: Group =
    (location.state && location.state.group) || {
      name: "Morning HIIT Warriors",
      description: "Daily high-intensity interval training discussion group.",
      category: "Fitness",
      members: 120,
      createdDate: "15 July 2025",
      status: true,
      reportedMessages: [
        {
          message: "This is spam message",
          reportedBy: "user123",
          reason: "Spam",
          date: "22 July 2025",
          status: "Pending"
        },
        {
          message: "Offensive language used",
          reportedBy: "user456",
          reason: "Offensive",
          date: "23 July 2025",
          status: "Reviewed"
        }
      ]
    };

  return (
    <>
      <div className="main_title">
        <h1>Community Group Details</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-community")}>
            Manage Community Groups
          </button>{" "}
          - View Group
        </p>
      </div>

      <div className="cards">
        <div className="view_page">
          <div className="gap_p">

            {/* Group Info */}
            <div className="w_33">
              <h6>Group Name</h6>
              <p>{group.name}</p>
            </div>

            <div className="w_33">
              <h6>Category</h6>
              <p>{group.category}</p>
            </div>

            <div className="w_33">
              <h6>Members Count</h6>
              <p>{group.members}</p>
            </div>

            <div className="w_100">
              <h6>Description</h6>
              <p>{group.description}</p>
            </div>

            <div className="w_33">
              <h6>Created Date</h6>
              <p>{group.createdDate}</p>
            </div>

            <div className="w_33">
              <h6>Status</h6>
              <p>
                <SwitchToggle defaultChecked={group.status} />
              </p>
            </div>

            {/* Reported Messages Table */}
            <div className="w_100 mt_30">
              <h4>Reported / Flagged Messages</h4>

              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Message Preview</TableCell>
                      <TableCell>Reported By</TableCell>
                      <TableCell>Reason</TableCell>
                      <TableCell>Report Date</TableCell>
                      <TableCell>Status</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {group.reportedMessages.length > 0 ? (
                      group.reportedMessages.map((msg, index) => (
                        <TableRow key={index}>
                          <TableCell>{msg.message}</TableCell>
                          <TableCell>{msg.reportedBy}</TableCell>
                          <TableCell>{msg.reason}</TableCell>
                          <TableCell>{msg.date}</TableCell>
                          <TableCell>{msg.status}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} style={{ textAlign: "center" }}>
                          No reports found.
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>

                </Table>
              </TableContainer>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCommunityGroup;
